import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ShieldCheck } from "lucide-react";
import { STORE } from "@/lib/catalog";

export default function Footer() {
  return (
    <footer className="relative bg-forest-dark text-bone overflow-hidden" data-testid="site-footer">
      <div className="pointer-events-none select-none absolute -bottom-10 left-1/2 -translate-x-1/2 font-serif font-bold italic text-[22vw] leading-none text-bone/[0.04] whitespace-nowrap">
        Shivam
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="font-serif font-bold text-2xl">
            Shivam <span className="italic text-saffron">Kirana</span> Store
          </p>
          <p className="mt-4 text-sm text-bone/70 leading-relaxed max-w-sm">
            Your trusted neighbourhood kirana for over two decades — fresh groceries,
            pure dairy, authentic spices and daily essentials, delivered to your doorstep.
          </p>
          <p className="mt-6 flex items-center gap-2 text-xs text-bone/50">
            <ShieldCheck className="w-4 h-4 text-saffron" /> FSSAI-compliant sourcing · Quality hand-checked daily
          </p>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-saffron">Explore</p>
          <ul className="mt-4 space-y-2.5 text-sm text-bone/80">
            <li><Link to="/" className="hover:text-saffron transition-colors" data-testid="footer-home-link">Home</Link></li>
            <li><Link to="/products" className="hover:text-saffron transition-colors" data-testid="footer-products-link">Products</Link></li>
            <li><Link to="/about" className="hover:text-saffron transition-colors" data-testid="footer-about-link">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-saffron transition-colors" data-testid="footer-contact-link">Contact Us</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-saffron">Legal</p>
          <ul className="mt-4 space-y-2.5 text-sm text-bone/80">
            <li><Link to="/privacy-policy" className="hover:text-saffron transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/disclaimer" className="hover:text-saffron transition-colors" data-testid="footer-disclaimer-link">Disclaimer</Link></li>
            <li><Link to="/admin" className="hover:text-saffron transition-colors" data-testid="nav-admin-link">Admin</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-saffron">Visit or Call</p>
          <ul className="mt-4 space-y-3 text-sm text-bone/80">
            <li className="flex items-start gap-2.5">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-saffron" /> {STORE.address}
            </li>
            <li className="flex items-center gap-2.5">
              <Phone className="w-4 h-4 shrink-0 text-saffron" />
              <a href={`tel:${STORE.phoneIntl.replace(/\s/g, "")}`} className="hover:text-saffron transition-colors">{STORE.phoneIntl}</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="w-4 h-4 shrink-0 text-saffron" />
              <a href={`mailto:${STORE.email}`} className="hover:text-saffron transition-colors break-all">{STORE.email}</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Clock className="w-4 h-4 shrink-0 text-saffron" /> {STORE.hours}
            </li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-bone/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-bone/50">
          <p>© {new Date().getFullYear()} Shivam Kirana Store. All rights reserved.</p>
          <p>Made with care in Kanpur, Uttar Pradesh.</p>
        </div>
      </div>
    </footer>
  );
}
